import { createReducer, on } from '@ngrx/store';
import { setAssistenceValueRelatedAction } from './assistenceValue.actions';



export const initialState = 0;

export const assistenceValueReducer = createReducer(
  initialState,
  on(setAssistenceValueRelatedAction, (state, { assistenceValueRelated }) => assistenceValueRelated)
);
